import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { useTrackingState } from 'contexts/TrackingProvider';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useCallback } from 'react';
import { useClient } from 'ui-hooks/useClient';
import { useCopyText } from 'ui-hooks/useCopyText';
import { useFeatureFlagConfig } from 'ui-hooks/useFeatureFlagConfig';
import { showAlertModal, showToast } from 'utils/modal';
import { SentryService } from 'utils/SentryService';

export const useShare = () => {
  const { tracker } = useTrackingState();
  const copyText = useCopyText();
  const { isApp } = useClient();
  const { isActiveFlag } = useFeatureFlagConfig();

  return useCallback(
    async (props: ShareData & { fileUrl?: string }) => {
      const title = props.title ? `${props.title} | 디리토` : '디리토';
      const text = props.text ?? '';
      const url = props.url?.trim() ?? '';

      tracker.track(TrackingEventType.Share, { title, text, url });

      if (isApp) {
        // 안드로이드에서 text 와 url 을 합쳐서 공유해준다.; 부득이하게 이렇게 나눈다.
        if (props.fileUrl) {
          DirittoAppBridge.share({ title, url: props.fileUrl, text });
        } else if (url) {
          DirittoAppBridge.share({ title, url });
        } else if (text) {
          DirittoAppBridge.share({ title, text, url: '' });
        } else {
          DirittoAppBridge.share({ title, url: '' });
        }
      } else if (navigator.share) {
        navigator.share({ title, url, text }).catch(e => {
          if (e.toString().includes('AbortError')) {
            // user cancel
            return;
          }
          SentryService.captureException(e);
        });
      } else {
        try {
          await copyText(url || text || title);
          showToast('링크가 클립보드에 복사되었어요.');
        } catch {
          showAlertModal('공유하기에 실패했어요.');
        }
      }
    },
    [copyText, isActiveFlag, isApp, tracker],
  );
};
